/* The same live filter panel is used in the desktop column and mobile dialog. */
(() => {
  'use strict';
  function setupDrawer(dialog) {
    const root = dialog.closest('[data-elite-sidebar-redesign]');
    if (!root || dialog.dataset.mobilePcFilterReady) return;
    const panel = root.querySelector('[data-elite-sidebar-panel]');
    const trigger = root.querySelector('[data-mobile-pc-filter-open]');
    const controls = root.querySelector('.elite-listing__browse-controls');
    const groups = dialog.querySelector('[data-mobile-pc-filter-groups]');
    if (!panel || !trigger || !controls || !groups || typeof dialog.showModal !== 'function') return;
    dialog.dataset.mobilePcFilterReady = 'true';
    dialog.dataset.eliteSidebarDrawer = '';
    trigger.dataset.mobilePcFilterReady = 'true';
    trigger.setAttribute('aria-expanded', 'false');
    const marker = document.createComment('Gaming PC sidebar desktop position');
    panel.before(marker);
    if (trigger.previousElementSibling !== controls) controls.after(trigger);
    // Keep the controls inside the listing: pricing and filtering query this root.
    root.append(dialog);
    const title = dialog.querySelector('.epc-mobile-filters__header h2');
    const badge = document.createElement('span');
    badge.setAttribute('data-elite-sidebar-count', '');
    title.append(document.createTextNode(' '), badge);
    dialog.querySelector('.epc-mobile-filters__clear').hidden = true;
    const mobile = window.matchMedia('(max-width: 749px)');
    const show = dialog.querySelector('[data-mobile-pc-filter-show]');
    let frame = 0;
    function update() {
      const count = Number(root.dataset.eliteSidebarCount || 0);
      badge.textContent = String(count);
      badge.setAttribute('aria-label', `${count} active filter${count === 1 ? '' : 's'}`);
      const status = root.querySelector('[data-collection-status]')?.textContent || '';
      const match = status.match(/Showing\s+(\d+)\s+of\s+(\d+)/i) || status.match(/Showing\s+(\d+)/i);
      const total = match ? Number(match[2] || match[1]) : null;
      const busy = root.classList.contains('is-loading') || /finding compatible|calculating|loading/i.test(status);
      show.disabled = busy;
      show.textContent = busy ? 'Updating PCs…' : total === null ? 'Show PCs' : `Show ${total} PC${total === 1 ? '' : 's'}`;
    }
    function queue() {
      if (frame) return;
      frame = requestAnimationFrame(() => { frame = 0; update(); });
    }
    function close() { if (dialog.open) dialog.close(); }
    function layout() {
      close();
      dialog.classList.remove('epc-desktop-filters');
      if (mobile.matches) groups.append(panel);
      else marker.after(panel);
      update();
    }
    trigger.addEventListener('click', () => {
      if (!mobile.matches) return;
      update();
      dialog.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('epc-mobile-filters-open');
      dialog.querySelector('[data-mobile-pc-filter-close]').focus({ preventScroll: true });
    });
    dialog.querySelector('[data-mobile-pc-filter-close]').addEventListener('click', close);
    show.addEventListener('click', close);
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('epc-mobile-filters-open');
      const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', 'false');
      if (mobile.matches && wasOpen) trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
    });
    dialog.querySelectorAll('[data-mobile-pc-filter-reset]').forEach(button => {
      button.textContent = 'Reset all';
      button.addEventListener('click', () => panel.querySelector('[data-elite-sidebar-reset]')?.click());
    });
    mobile.addEventListener('change', layout);
    const observer = new MutationObserver(queue);
    observer.observe(root, { attributes: true, attributeFilter: ['class', 'data-elite-sidebar-count'] });
    const status = root.querySelector('[data-collection-status]');
    if (status) observer.observe(status, { childList: true, characterData: true, subtree: true });
    layout();
  }
  window.ElitePCSidebar = { setupDrawer };
  const boot = () => document.querySelectorAll('[data-elite-sidebar-redesign] [data-mobile-pc-filter-dialog]').forEach(setupDrawer);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
